/**************************************************
 * Nombre:       Seccion_Sub_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO, CASILLA_MONEDA,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {ESTADOSUSUARIOS} from "../../Constantes";
import Dialogo_Producto from "../Dialogos/Producto/Dialogo_Producto";
import Dialogo_Categoria from "../Dialogos/Dialogo_Categoria";
import Dialogo_Sub_Categoria from "../Dialogos/Dialogo_Sub_Categoria";


const Seccion_Sub_Categorias = () => {
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'subcategorias'});
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Sub_Categoria,
        titulo: 'Detalles de subcategoria',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista sub categorias'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Sub_Categorias

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    }

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]